import React, { useEffect, useState } from 'react'
import { Pagination, Space, Divider } from 'antd'
import './aitools.less'
import AitoolsCard from './aitoolsCard'
import SearchBar from 'components/SearchBar'


export interface AiTools {
  id: string
  name: string
  desc: string
  info: string
  type: string
  logo: string
  image: string
  url: string
}


const AitoolsCom = () => {
  const [current, setCurrent] = useState(1)
  const handlePageChange = page => {
    setCurrent(page)
  }

  const [fileType, setFileType] = useState('all')
  const [resourceList, setResourceList] = useState<AiTools[]>([])
  const [total, setTotal] = useState(0)

  const handleTypeClick = t => {
    if (t.type === fileType) {
      return
    }

    setFileType(t.type)
  }


  const planTools = [{
    id: "11",
    name: "文心一言",
    type: "plan",
    desc: "百度全新一代知识增强大语言模型，文心大模型家族的新成员，能够与人对话互动、回答问题、协助创作，高效便捷地帮助人们获取信息、知识和灵感。",
    info: "文心一言官网向广大用户提供对话交互、内容创作、知识推理、多模态生成等模型能力，辅助用户工作、学习、生活中的各类需求；并上线了一言百宝箱、新手引导、问题推荐、标题摘要、回答复制、回答分享、历史对话管理等功能，帮助用户更便捷、深入地使用大语言模型；此外，文心一言官网还推出了多个原生插件：如百度搜索、览卷文档、E言易图、说图解画等，进一步拓展了大语言模型的能力边界，更广泛地满足用户需要。",
    logo: "images/wenxin-logo.png",
    image: "images/yiyan.jpg",
    url: "https://yiyan.baidu.com/"
  }, {
    id: "12",
    name: "通义千问",
    type: "plan",
    desc: "阿里巴巴最新推出的类ChatGPT响应人类指令的大模型",
    info: "通义千问，是阿里云推出的一个超大规模的语言模型，功能包括多轮对话、文案创作、逻辑推理、多模态理解、多语言支持。能够跟人类进行多轮的交互，也融入了多模态的知识理解，且有文案创作能力，能够续写小说，编写邮件等。",
    logo: "images/tongyi-logo.png",
    image: "images/qianwen.jpg",
    url: "https://tongyi.aliyun.com/qianwen/"
  }, {
    id: "13",
    name: "Kimi",
    type: "plan",
    desc: "一款国产AI大模型，其核心功能在于强大的长文本处理能力和多语言对话能力。",
    info: "Kimi作为一款国产AI大模型，其核心功能在于强大的长文本处理能力和多语言对话能力。与许多其他AI大模型不同的是，Kimi能够处理高达200万字的文本，这在当前AI大模型领域是非常突出的表现。这一功能使其在学术研究、法律文本分析、API文档理解等领域具有显著优势。同时，Kimi还支持中英文以及其他多种语言的对话，使其成为一个全球化的交流工具。",
    logo: "images/kimi-logo.png",
    image: "images/kimi.jpg",
    url: "https://kimi.moonshot.cn/"
  },]
  const pptTools = [{
    id: "2",
    name: "AiPPT",
    type: "ppt",
    desc: "一款AI驱动的PPT在线生成工具。无需复杂操作，只需输入主题AI即可一键生成高质量PPT。",
    info: `AiPPT是一款Ai驱动的PPT在线生成工具。无需复杂操作，只需输入主题AI即可一键生成高质量PPT。支持在线自定义编辑和文档导入生成，配置超10w+定制级模板及素材，助力快速产出专业级PPT。\n功能介绍：\n1、AI智能一键生成PPT。基于人工智能和自然语言处理技术，能智能理解用户输入的主题，并快速生成符合需求的PPT内容\n2、支持多种文档格式上传生成，快速上传，一键生成。\n3、内置上千套定制级模板。支持一键替换模板样式，内容始终如一，风格千变万化！\n4、自由灵活的编辑能力。无论何时生成出来的文案还是PPT 幻灯片，都能随意调整，包括页面、形状、字体、颜色、大小等细节，都能自由编辑。\n5、云端存储，在线放映。文件可实时保存，打开网站就能在线编辑，支持在线放映。`,
    logo: "images/aippt-logo.png",
    image: "images/aippt.jpg",
    url: "https://www.aippt.cn/"
  }, {
    id: "21",
    name: "比格AI PPT",
    type: "ppt",
    desc: "比格AI PPT是比格设计一款以大语言模型为基础的生成式人工智能应用，它能够实现一键生成PPT的功能。",
    info: "比格AI PPT是一个基于大语言模型的生成式人工智能应用，主要为用户提供便捷的PPT制作服务。用户只需输入主题，即可在一分钟内生成一套完整的PPT。此外，比格AI PPT还支持对PPT大纲的修改、模板一键更换以及风格的更换等功能，满足用户多样化的需求。",
    logo: "images/bige-logo.png",
    image: "images/bige.jpg",
    url: "https://bigesj.com/ai-ppt/"
  }, {
    id: "22",
    name: "iSlide AI",
    type: "ppt",
    desc: "iSlide公司推出的AI辅助PPT设计工具，具备丰富的模板、图示和图标库资源，还提供一键优化、智能图表设计等功能",
    info: "iSlide AI的核心优势在于其强大的AI设计助手功能。用户只需输入相应的主题或内容要求，iSlide AI就能够智能推荐适合的设计元素和布局方案，实现快速设计。此外，iSlide AI提供的一键优化功能能够自动调整演示文稿中的字体、颜色和布局，确保整体设计风格的专业性和一致性。并且iSlide AI拥有庞大的模板和素材库，包括各种风格的PPT模板、图示、图表和图标，用户可以根据需要自由选择和应用合适的设计资源。",
    logo: "images/islide-logo.png",
    image: "images/islide.jpg",
    url: "https://www.islide.cc/ai-beta"
  }, {
    id: "23",
    name: "ChatPPT",
    type: "ppt",
    desc: "必优科技旗下AI生成PPT的办公产品。",
    info: "必优科技旗下的ChatPPT是一款创新的AI生成PPT的办公产品，旨在通过先进的人工智能技术帮助用户自动生成专业的演示文稿，节省时间并提升工作效率。ChatPPT利用了最新的人工智能技术来简化传统的演示文稿制作过程。此产品能够根据用户提供的关键词或简短的描述，自动生成包含丰富图表、文本和布局的PPT，极大地减少了制作演示文稿所需的时间和精力。ChatPPT不仅提高了制作效率，还通过其智能设计建议保证了演示文稿的专业性和视觉吸引力。此外，ChatPPT还支持用户对生成的PPT进行个性化调整，满足不同场合和目的的需求。",
    logo: "images/chatppt-logo.png",
    image: "images/chatppt.jpg",
    url: "https://www.chat-ppt.com/"
  },]
  const resTools = [{
    id: "3",
    name: "文心一格",
    type: "res",
    desc: "文心一格，AI艺术和创意辅助平台，依托飞桨、文心大模型的技术创新推出的“AI作画”产品，可轻松驾驭多种风格，人人皆可“一语成画”。",
    info: "文心一格是由百度推出的依托其文心大模型和飞桨技术的文本生成图片的 AI 艺术和创意辅助平台，于2022年8月正式发布。作为国内第一梯队的AI图片生成的工具和平台，文心一格可以进行国风、油画、水彩、水粉、动漫、写实等十余种不同风格高清画作的生成。",
    logo: "images/wenxin-logo.png",
    image: "images/yige.jpg",
    url: "https://yige.baidu.com/"
  }, {
    id: "31",
    name: "360智绘",
    type: "res",
    desc: "360旗下的AI生图工具。",
    info: " 360智绘专注于风格化的AI绘图场景，助您轻松创作精美AI作品，产品包含AI画廊、模型广场、LoRA模型训练等功能。",
    logo: "images/360-logo.png",
    image: "images/zhihui.jpg",
    url: "https://aigc.360.com/"
  }, {
    id: "32",
    name: "腾讯智影",
    type: "res",
    desc: "腾讯智影是一款云端智能视频创作工具，集素材搜集、视频剪辑、渲染导出和发布于一体的免费在线剪辑平台。",
    info: "腾讯智影是一款云端智能视频创作工具，集素材搜集、视频剪辑、渲染导出和发布于一体的免费在线剪辑平台。强大的AI智能工具，支持文本配音、数字人播报、自动字幕识别、文章转视频、去水印、视频解说、横转竖等功能，拥有丰富的素材库，极大提升创作效率，帮助用户更好地进行视频化的表达。",
    logo: "images/zhiying-logo.png",
    image: "images/zhiying.jpg",
    url: "https://zenvideo.qq.com/"
  }, {
    id: "33",
    name: "度加创作",
    type: "res",
    desc: "百度官方出品的AIGC创作平台",
    info: "度加创作工具是由百度出品的、人人可用的AIGC创作工具网站。度加致力于通过AI能力降低内容生产门槛，提升创作效率，一站式聚合百度AIGC能力，引领跨时代的内容生产方式。度加的主要功能包括AI成片（图文成片/文字成片）、AI笔记（智能图文生成）、AI数字人等。",
    logo: "images/dujia-logo.png",
    image: "images/dujia.jpg",
    url: "https://aigc.baidu.com/"
  }, {
    id: "34",
    name: "快转字幕",
    type: "res",
    desc: "新一代AI字幕工作站",
    info: "快速生成多语言字幕，准确语音转文字、精准翻译；为亚洲语言量身打造优化和适配，使翻译更加通顺自然；独家智能重排技术根据上下文给字幕重新断句，保证观看和阅读体验；媲美翻译专家的 AI 翻译工具深度语境解析能力，让每条翻译达到信、达、雅的高标准",
    logo: "images/kuaizhuan-logo.png",
    image: "images/kuaizhuan.jpg",
    url: "https://www.kzzimu.com/"
  }, {
    id: "35",
    name: "悦音配音",
    type: "res",
    desc: "AI智能在线配音语音合成工具",
    info: "悦音配音是制片帮旗推出的一款AI智能在线配音语音合成工具，可以帮助用户在线将文字输入快速轻松转换成语音。该AI配音工具提供男声、女声、童声、普通话、方言、英文等多种真人声音，在你输入文字后便可以直接智能生成音频。",
    logo: "images/yueyin-logo.png",
    image: "images/yueyin.jpg",
    url: "https://yueyin.zhipianbang.com/"
  },]
  const docTools = [{
    id: "4",
    name: "WPS AI",
    type: "doc",
    desc: "金山办公旗下基于大语言模型的智能办公助手",
    info: "接入“WPS AI”后，AI生成的内容可以直接嵌入到文档正文，并能按照当前文档所能支持的格式进行实时渲染，同时也支持多轮对话，通过多次、连续自然语言的输入控制内容的生成，进一步提高创作效率。“WPS AI”提供的起草、改写、总结、润色、翻译、续写等功能，覆盖了用户大部分使用场景，例如针对用户输入的文字需求，将会帮助用户生成工作总结、广告文案、社媒推文、文章大纲、招聘文案、待办事项、创意故事、旅行游记等。用户在和AI的交互过程中，还可以插入一篇或多篇已有的文档，作为AI内容生成的参考素材，使生成的内容更具备用户已有内容的相关性，例如插入多篇工作日报，让AI生成出一周的工作总结",
    logo: "images/wpsai-logo.png",
    image: "images/wpsai.jpg",
    url: "https://ai.wps.cn/"
  }, {
    id: "41",
    name: "有道速读",
    type: "doc",
    desc: "网易有道推出的一个AI辅助的论文和文档阅读工具",
    info: "有道速读是由网易有道推出的一个AI辅助的论文和文档阅读工具，旨在帮助用户快速从文档中提取、定位和汇总信息。该工具为用户提供了一站式解决方案，涵盖文档翻译、文档解析和文档问答（QA）等功能，特别适合需要处理大量英文长篇资料的研究人员和学生。",
    logo: "images/sudu-logo.png",
    image: "images/sudu.jpg",
    url: "https://read.youdao.com/"
  }, {
    id: "42",
    name: "通义智文",
    type: "doc",
    desc: "通义智文是阿里云推出的一款基于先进的人工智能大模型技术的免费AI阅读助手。",
    info: "通义智文是阿里云推出的一款基于先进的人工智能大模型技术的免费AI阅读助手。这款工具设计的主要目的是为了帮助用户在信息爆炸的时代更高效、智能地处理和理解各种形式的文本内容，包括网页、学术论文、图书和各类文档等。",
    logo: "images/tongyi-logo.png",
    image: "images/zhiwen.jpg",
    url: "https://tongyi.aliyun.com/zhiwen"
  },]


  const upadteResourceList = () => {
    console.log(fileType)
    let tools;
    switch (fileType) {
      case 'plan':
        tools = planTools
        break
      case 'ppt':
        tools = pptTools
        break
      case 'res':
        tools = resTools
        break
      case 'doc':
        tools = docTools
        break
      default:
        tools = [...planTools, ...pptTools, ...resTools, ...docTools]
    }
    setResourceList(tools)
    setTotal(tools.length)
  }

  useEffect(() => {
    //  重新获取数据并渲染
    upadteResourceList()
  }, [current, fileType])


  const fileTypes = [
    {
      text: '全部',
      type: 'all',
    },
    {
      text: 'AI教案编写',
      type: 'plan',
    },
    {
      text: 'AI课件制作',
      type: 'ppt',
    },
    {
      text: 'AI资源生成',
      type: 'res',
    },
    {
      text: 'AI文档分析',
      type: 'doc',
    },
  ]


  return (
    <>
      <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/resource-banner.png)` }}>
        <SearchBar module="AI Tools" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <div className="resource-container">

          <div className="resource-type-container">
            <div>
              {fileTypes.map((t, index) => (
                <div className="resource-text" key={index}>
                  <span
                    className={`resource-text-titile-common ${fileType === t.type ? 'resource-text-title' : null
                      }`}
                    onClick={() => handleTypeClick(t)}
                  >
                    {t.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <Divider className="resource-divider" />
          <div className="resource-card-container">
            <Space size={[30, 30]} wrap style={{ marginBottom: 0 }}>
              {resourceList.map((r, index) => (
                <AitoolsCard resource={r} key={r.id} />
              ))}
            </Space>
          </div>
          <div className="resource-footer">
            <div>
              <span>共 {total} 条内容</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AitoolsCom
